export default {
    component: () => import('./index'),
    meta: {
        nav: {
            title: '首页'
        }
    }
};
